import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/Search/SearchBar/searchBar.container"
    ).then((module) => ({
        default: module.SearchBar
    }))
);
